import type { FC } from 'react';
import type { Theme } from '@material-ui/core';
import { experimentalStyled, useTheme } from '@material-ui/core/styles';
import type { SxProps } from '@material-ui/system';
import { ReactComponent as Imagen } from '../assets/img/logo-slogan.svg';
import { ReactComponent as ImagenDark } from '../assets/img/logo-dark.svg';

interface LogoProps {
  sx?: SxProps<Theme>;
}

const LogoRoot = experimentalStyled('svg')();

const Logo: FC<LogoProps> = (props) => (
  <LogoRoot
    // height="52"
    version="1.1"
    // viewBox="0 0 52 52"
    // width="52"
    {...props}
  >
    <title>Prior</title>
    {useTheme().palette.mode === 'light' ? (
      <Imagen height="225px" width="400px" />)
      : (
        <ImagenDark />
      )}
  </LogoRoot>
);

export default Logo;
